import React from "react";

export interface ErrorTextProps {
    text?: string
    className?: string
}

export class ErrorText extends React.Component<ErrorTextProps, {}> {
    render() {
        if (!this.props.text || this.props.text.length == 0) {
            return null;
        }
        return <div className={
            `form-error mt-1` +
            `${this.props.className ? (' ' + this.props.className) : ''}`
        }>
            {this.props.text}
        </div>;
    }
}